import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function AddExpense(){
    const [cat, setCat] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [expenseData,setexpenseData]=useState({
        "receipt":'',
        "type":'',
        "amount":'',
        "mode":'',
        "reason":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });

    const handleChange = (event) => {
        setexpenseData({
            ...expenseData,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
      axios.post(`${baseUrl}get_exp_id/`)
      .then(response => {
        const receipt = response.data.value;
        const _formData = new FormData();
        _formData.append('receipt',receipt);
        _formData.append('type',expenseData.type);
        _formData.append('amount',expenseData.amount);
        _formData.append('mode',expenseData.mode);
        _formData.append('reason',expenseData.reason);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        try{
            axios.post(baseUrl+'expense/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:5000,
                        showConfirmButton: false
                    });
               window.location.reload();
               }
            });
            }catch(error){
                console.log(error);
            }
          })
          .catch(error => {
            console.log(error);
            Swal.fire(
              'Error!',
              'Failed to generate unique value. Please try again later.',
              'error'
            );
          });
      };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (cat.length > 0) {
        setRows(cat);
      }
  }, [cat]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}expense/`)
      .then(response => {
        setCat(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

    const handleDelete = (exp_id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-expense/'+exp_id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
    { field: 'id', headerName: 'Id', width: 70 },
    { field: 'type', headerName: 'Type', width: 150},
    { field: 'receipt', headerName: 'Receipt', width: 200 },
    { field: 'amount', headerName: 'Amount', width: 130 },
    { field: 'mode', headerName: 'Pay Mode', width: 130 },
    { field: 'reason', headerName: 'Reason', width: 180 },
    { field: 'addedby', headerName: 'Added By', width: 120},

    { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
    width: 120 },

  ];
  const getTotal = (rows, field) => {
    return rows.reduce((total, row) => total + parseFloat(row[field]), 0);
  };

   const Footer = ({ rows }) => {
      const totalexpenseAmount = getTotal(rows, 'amount');
      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
          <div>Total</div>
          <div>{totalexpenseAmount}</div>
        </div>
      );
    };

    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Add Expense</h4>
                    <div className='card-body'>
                        <form>
                          <div className="mb-3">
                            <label htmlFor="type" className="form-label">Expense Type</label>
                            <select name="type" value={expenseData.type} onChange={handleChange} className="form-control">
                                 <option >Select</option>
                                 <option value="ambulance">Ambulance</option>
                                 <option value="ot-charges">OT-Expense</option>
                                 <option value="other expences">Other Expense</option>
                                 <option value="advance">Advance</option>
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="amount" className="form-label">Amount</label>
                            <input type="number" className="form-control" name="amount" value={expenseData.amount}
                            onChange={handleChange} id="amount" />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="mode" className="form-label">Choose Pay Mode</label>
                            <select name="mode" value={expenseData.mode} onChange={handleChange} className="form-control">
                                   <option>Choose Payment Mode</option>
                                   <option value="cash">Cash</option>
                                   <option value="card">Credit Card</option>
                                   <option value="cheque">Cheque</option>
                                   <option value="UPI">UPI</option>
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="reason" className="form-label">Reason</label>
                            <input type="text" className="form-control" name="reason" value={expenseData.reason}
                            onChange={handleChange} id="reason" />
                          </div>
                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>


        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
             slots={{
              toolbar: GridToolbar,
              footer: () => <Footer rows={rows} />,
            }}
            autoHeight
          />
          </div>

        </section>

)
}

export default AddExpense;